import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { openSignUrl } from "../../utils/HelperFunction";
import MyDataTable from "../../component/MyDataTable";
import MainBody from "../../component/MainBody";
import { useSelector } from "react-redux";
import httpRequest from "../../utils/Http";
import { toast } from "react-toastify";

const MiscChargeOnApproval = () => {
  const [reloadList, setReload] = useState(true);
  const user = useSelector((state) => state.authReducer.currentUser);

  const UpdateOnStatus = async (id, status) => {
    // Implement the logic to update the status of the miscellaneous charge
    if (window.confirm("Are you sure you want to update the status?")) {
      if (id && status) {
        const response = await httpRequest(
          "approvemisccharges",
          { id, status },
          "POST"
        );
        if (response && response.status) {
          toast.success(response.message);
          setReload(true);
        } else {
          toast.error(response.message);
        }
      }
    }
  };

  const UpdateReject = async (id, status) => {
    const reason = window.prompt("Please provide a reason for rejection:");
    if (reason !== null) {
      if (id && status) {
        const response = await httpRequest(
          "approvemisccharges",
          { id, status, reason },
          "POST"
        );
        if (response && response.status) {
          toast.success(response.message);
          setReload(true);
        } else {
          toast.error(response.message);
        }
      }
    }
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: "Booking ID",
      selector: (row) => row.booking_detail.booking_id,
      cell: (row) => (
        <NavLink to={`/getbookingdetails?bid=${btoa(row.booking_detail.id)}`}>
          {row.booking_detail.booking_id}
        </NavLink>
      ),
    },
    {
      name: <div className="word-wrap">Product/Service</div>,
      wrap: true,
      selector: (row) => row.service,
    },
    {
      name: <div className="word-wrap">Description</div>,
      selector: (row) => row.description,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Amount</div>,
      selector: (row) => row.partner_charge,
    },
    {
      name: <div className="word-wrap">Remarks</div>,
      selector: (row) => row.remarks,
      wrap: true,
    },
    {
      name: "Files",
      wrap: true,
      selector: (row) => "",
      cell: (row) => (
        <div className="word-wrap">
          {row?.purchase_file && (
            <Link
              to={"#"}
              onClick={() => {
                openSignUrl(row.purchase_file);
              }}
              target="_blank"
              className="btn btn-sm btn-link"
              rel="noopener noreferrer"
            >
              Purchase File
            </Link>
          )}
          <br />
          {row?.approval_file && (
            <Link
              to={"#"}
              onClick={() => {
                openSignUrl(row.approval_file);
              }}
              target="_blank"
              className="btn btn-sm btn-link"
              rel="noopener noreferrer"
            >
              Approval File
            </Link>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },

    {
      name: <div className="word-wrap">Receive</div>,
      cell: (row) => (
        <button
          className="btn btn-primary"
          onClick={() => UpdateOnStatus(row.id, 1)}
        >
          Approve
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
    {
      name: <div className="word-wrap">Reject</div>,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={(e) => {
            UpdateReject(row.id, 2);
          }}
        >
          Reject
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);
  return (
    <div>
      <MainBody
        breadcrumbTitle="Misc Charges on Approval"
        breadcrumbSubTitle={"List"}
        navButton={""}
        title={""}
        component={
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">
                        Miscellaneous Charges on Approval
                      </h3>
                    </div>
                    {user && user.entity_id && (
                      <MyDataTable
                        reloadList={reloadList}
                        columns={columns}
                        getDataListURL={`getmiscchargesonapproval?partner_id=${user.entity_id}`}
                        setReload={setReload}
                        exportName={"miscchargeonapproval"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
      />
    </div>
  );
};

export default MiscChargeOnApproval;
